var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sidebar-item',{attrs:{"link":{name: _vm.$t('Пользователи'), icon: 'nc-icon nc-single-02', path: `/user`}}})
}
var staticRenderFns = []

export { render, staticRenderFns }